/** CanExport SME — export market development for SMEs. */
export const CANEXPORT_SME_TASKS = [
  {
    id: 1,
    name: "Eligibility & market selection",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm SME eligibility (revenue, ownership, export readiness)", completed: false },
      { id: "1-2", name: "Identify target export market(s) with client", completed: false },
      { id: "1-3", name: "Review prior CanExport funding history", completed: false },
    ],
  },
  {
    id: 2,
    name: "Build export plan",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Draft export marketing / business development plan", completed: false },
      { id: "2-2", name: "Itemize eligible activities and budget (max grant rules)", completed: false },
      { id: "2-3", name: "Client sign-off on plan and cost-share commitment", completed: false },
    ],
  },
  {
    id: 3,
    name: "Application & claims",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Submit application via CanExport portal", completed: false },
      { id: "3-2", name: "Execute approved export activities", completed: false },
      { id: "3-3", name: "Prepare claim documentation (invoices, travel, reports)", completed: false },
      { id: "3-4", name: "Submit reimbursement claim and track payment", completed: false },
    ],
  },
];

/** CanExport Innovation — R&D collaboration for export-oriented innovation. */
export const CANEXPORT_INNOVATION_TASKS = [
  {
    id: 1,
    name: "Innovation & export fit",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm innovation project ties to export growth", completed: false },
      { id: "1-2", name: "Verify company and project eligibility", completed: false },
      { id: "1-3", name: "Identify research partner or internal R&D scope", completed: false },
    ],
  },
  {
    id: 2,
    name: "Project proposal",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Draft technical objectives and commercialization plan", completed: false },
      { id: "2-2", name: "Build budget (eligible R&D and related export costs)", completed: false },
      { id: "2-3", name: "Internal review and client approval", completed: false },
    ],
  },
  {
    id: 3,
    name: "Submit & manage project",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Submit via CanExport Innovation stream", completed: false },
      { id: "3-2", name: "Track contribution agreement and reporting milestones", completed: false },
      { id: "3-3", name: "File interim/final claims with supporting evidence", completed: false },
    ],
  },
];
